import { HamburgerIcon } from "../../utils/heroIcons";

export const Hamburger = ({ customClasses = "h-6 w-6" }) => {
  return (
    <span>
      <HamburgerIcon customClasses={customClasses} />
    </span>
  );
};
